module.exports = __webpack_public_path__ + "img/Mädel.07aab5a6.svg";